import {Flex, Text} from "@chakra-ui/react";
import {useIntl} from "next-intl";
import React from "react";

import useShoppingCart from "../../hooks/useShoppingCart";

function CheckoutPriceValues() {
    const {
        shoppingCartTotal,
        shoppingCartSubTotal,
        shoppingCartTaxesAndFees,
        shoppingCartDiscountAmount,
    } = useShoppingCart()
    const intl = useIntl();
    return (
        <>
            <Flex justify='space-between' align='flex-end'>
                <Text fontSize='sm'> Subtotal </Text>
                <Text fontSize='sm'>{intl.formatNumber(shoppingCartSubTotal, {
                    style: 'currency',
                    currency: 'USD'
                })}</Text>
            </Flex>
            <Flex justify='space-between' align='flex-end'>
                <Text fontSize='sm'> Taxes & Fees </Text>
                <Text fontSize='sm'>{intl.formatNumber(shoppingCartTaxesAndFees, {
                    style: 'currency',
                    currency: 'USD'
                })} </Text>
            </Flex>
            {Number(shoppingCartDiscountAmount) > 0 && (<Flex justify='space-between' align='flex-end'>
                <Text fontSize='sm'>Discount</Text>
                <Text fontSize='sm'>-{intl.formatNumber(shoppingCartDiscountAmount, {
                    style: 'currency',
                    currency: 'USD'
                })} </Text>
            </Flex>)}
            <Flex justify='space-between' align='flex-end' fontWeight="bold">
                <Text fontSize='sm'> Total </Text>
                <Text fontSize='sm'> {intl.formatNumber(shoppingCartTotal, {
                    style: 'currency',
                    currency: 'USD'
                })} </Text>
            </Flex>
        </>
    )
}

export default CheckoutPriceValues